// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pf_a bhb_cw bhb_jx bhb_jo bhb_a bhb_j bhb_ri bhb_rj","SearchPanel__icon":"pf_b bhb_ui bhb_hb bhb_ro bhb_tu","SearchPanel__input":"pf_c bhb_iv bhb_cx bhb_z"};